// extracted by mini-css-extract-plugin
module.exports = {"gridImages":"Images_grid-images__1S6NB","gridThumbImage":"Images_grid-thumb-image__2dNk9","gridThumbImg":"Images_grid-thumb-img__1-_Sj"};